/**
 * @(#)2019/6/17.
 * YxPanel，折叠面板
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import { Collapse } from "antd";
import ReactDOM from "react-dom";
import style from "./index.less";
import React, { Component } from "react";
import { isObject, isArray, isString } from "lodash";
import { get, toArray } from "../../utils/index";
import { YxComponent, Connection } from "../YxComponent";
import { YxText } from "yx-widget";
import Utils, { nodeFactory, merge, getBatch } from "../../utils";

const YxIcon = YxText.Icon;

/*
 * @param extraHeader {note} 扩展的头部，跟随子标题
 * @param styleType {object} 组件的样式类型  noneBorder 无边框
 * @param className {string} 组件的class
 * @param header {string | ReactNode | boole} 面板头部信息，如果为false隐藏头部
 * @param isContentScroll {boole} 是否允许内容区滚动,该属性如果设置为true，必须设置contentHeight
 * @param contentHeight {boole} 内容区高度
 *
 * @param styleParam {object} ui样式参数
 * @param styleParam.type {object} 类型 default/border   无边框和有边框模式
 * @param styleParam.size {object} 大小 default/border   无边框和有边框模式
 *
 * @param isFold {boole} 是否允许折叠，这个和disabled的区别是不会置灰
 * @param disabled {bool} 是否禁用面板折叠操作
 * @param change {function} 面板折叠或打开后的回调
 * @param showArrow {bool} 是否显示右边图标
 * @param defaultValue{boole} 初始化否展开，默认true
 * @param expandIcon {{ isActive } = ReactNode} 自定义右边图标，isActive指是否折叠参数   比如  ({ isActive }) => <Icon type="caret-right" rotate={isActive ? 90 : 0} />
 * @param headerStyleParam 可给头部自定义样式
 * @param extra {ReactNode} 自定义右上角内容
 * @param footerNode {ReactNode} 底部栏的内容
 * @param subheading {string | ReactNode} 底部栏的内容
 * @param containerParam {object} 面板容器div的参数
 * @param headerTextIcon {string} 表格文字的自定义图标 值为antd的icon的type
 * */
let defaul = () => {
  return {
    headerTextIcon: "",
    styleParam: {
      type: "default", //类型   default/border/nonegPadding
      // size:"default", //大小  default/border
    },
    isContentScroll: false, //是否允许内容区滚动,该属性如果设置为true，必须设置contentHeight
    contentHeight: "", //内容区高度
    className: "", //className
    header: "", //title信息,如果空，则隐藏头部
    subheading: "", //副标题
    disabled: null,
    change: () => {}, //面板发生折叠时的回调函数
    showArrow: false, //是否显示右边图标
    expandIcon: "", //自定义图标
    extra: "", //自定义右上角内容
    isFold: false, //是否允许折叠
    children: "", //子节点
    footerNode: "", //底部栏的内容
    defaultValue: true, //默认是否展开
    forceRender: false, //折叠是否渲染节点
    containerParam: {},
    deep: false,
  };
};

@Connection(defaul)
class YxPanel extends YxComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      activeKey: "1",
    };
    this.divClass = "yx_panel_box";
  }

  get isHeader() {
    const list = getBatch(
      this.props,
      ["extraHeader", "subheading", "header"],
      null
    );
    return !list.every((l) => l == null || l == "");
  }

  panelParam(tmpProps) {
    const disabled = get(tmpProps, "disabled", null);
    const isFold = get(tmpProps, "isFold", true);
    const className = [
      isFold === false && disabled !== true ? "no_fold_ant-collapse-item" : "",
    ];
    const extraHeader = nodeFactory(get(tmpProps, "extraHeader", null));
    //副标题
    let subheading = (
      <span className="yx_yxPanel_subheading">
        {nodeFactory(tmpProps.subheading)}
      </span>
    );
    let headerTextIcon = () => {
      let headerTextIconUrl = get(tmpProps, "headerTextIcon");
      return headerTextIconUrl ? (
        <YxIcon className="headerTextIcon" type={headerTextIconUrl} />
      ) : (
        ""
      );
    };
    let headerClass = get(tmpProps, "headerTextIcon")
      ? "yx_yxPanel_headerMain"
      : "";
    const header = (
      <div className={headerClass} style={tmpProps.headerStyleParam}>
        {headerTextIcon()}
        {nodeFactory(tmpProps.header)}
        {subheading}
        {extraHeader}
      </div>
    );
    return {
      header,
      key: "1",
      showArrow: tmpProps.showArrow,
      className: className.join(" "),
      forceRender: tmpProps.forceRender,
      disabled: disabled == null ? !isFold : disabled,
      extra: nodeFactory(toArray(tmpProps.extra), this.props.data),
    };
  }

  //判断应该添加哪些class
  classNames(tmpProps) {
    let classParam = {
      yx_yxPanel_: "styleParam.type",
      yx_yxPanel_size_: "styleParam.type", //size和类型保持一致
    };
    //内容区是否滚动
    tmpProps.isContentScroll
      ? (classParam.yx_yxPanel_isContentScroll = "")
      : "";
    //是否显示标题栏
    !tmpProps.header ? (classParam.yx_yxPanel_noneHeader = "") : "";
    isObject(tmpProps.header) ? (classParam.yx_yxPanel_isTabs = "") : "";
    //判断要不要给面板右边padding
    isArray(tmpProps.extra) && tmpProps.extra.length > 0
      ? (classParam.yx_yxPanel_tabsRightPadding = "")
      : "";
    classParam = this.styleParamClassName(tmpProps, classParam);
    return classParam;
  }

  productionHtml() {
    let tmpProps = { ...this.props };

    tmpProps.className = this.classNames(tmpProps);
    // 当为字符串格式当成icon 节点处理
    const iconName = tmpProps.expandIcon;
    if (isString(iconName) && iconName) {
      //避免expandIcon 参数为空字符串''，报警告问题
      tmpProps.expandIcon = () => {
        return <YxIcon type={iconName} />;
      };
    }

    let collapseParam = {
      expandIcon: tmpProps.expandIcon,
      onChange: tmpProps.change,
      defaultActiveKey: tmpProps.defaultValue ? "1" : null,
      className: tmpProps.className,
      expandIconPosition: get(tmpProps, "expandIconPosition", "right"),
    };
    const baseStryle = tmpProps.contentHeight
      ? { height: tmpProps.contentHeight }
      : {};
    let html = (
      <Collapse {...collapseParam}>
        <Collapse.Panel {...this.panelParam(tmpProps)}>
          <div
            className="yx_yxPanel_content"
            header={`${this.isHeader}`}
            border={`${this.props.styleParam.type === "border"}`}
            style={baseStryle}
          >
            {tmpProps.children}
            {tmpProps.footerNode ? (
              <div className="yx_yxPanel_foot">{tmpProps.footerNode}</div>
            ) : (
              ""
            )}
          </div>
        </Collapse.Panel>
      </Collapse>
    );
    return html;
  }

  get containerParam() {
    return {
      className: this.parentClass,
      ...get(this.props, "containerParam", {}),
    };
  }

  render() {
    return <div {...this.containerParam}>{this.productionHtml()}</div>;
  }
}
export default YxPanel;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxPanel/YxPanel.js